export * from './regularize-payment.page'
